import { ActivitySpinnerWidget } from '@tableau/widgets';
import * as React from 'react';
import { divWithStyle } from './style/LayoutComponents';
import { keyframes, Style } from './style/StyleFunctions';

const fadeInAnimation = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
});

const fadeInStyle: Style = {
  animationName: fadeInAnimation,
  animationDuration: '2s',
  animationTimingFunction: 'ease-in',
};

const centeredStyle: Style = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};


const CenteredContainer = divWithStyle('CenteredContainer', centeredStyle);
const CenteredFadeInContainer = divWithStyle('CenteredFadeInContainer', [centeredStyle, fadeInStyle]);


export function CenteredFadeInSpinner(): JSX.Element {
  return (
    <CenteredFadeInContainer>
      <ActivitySpinnerWidget testId='' />
    </CenteredFadeInContainer>
  );
}

export function CenteredSpinner(): JSX.Element {
  return (
    <CenteredContainer>
      <ActivitySpinnerWidget testId='' />
    </CenteredContainer>
  );
}
